import { Injectable } from '@angular/core';
import { UserRoles } from 'src/app/core/enums';

@Injectable({
  providedIn: 'root',
})
export class LocationPermissionUtils {
  canEditLocation(role: UserRoles | undefined) {
    // NOT INCLUDED: GROUPADMIN, GROUPMANAGER, GROUP, USER, LOCMGR
    return role === UserRoles.ADMIN || role === UserRoles.GROUP_COORDINATOR;
  }

  canAddLocation(role: UserRoles | undefined) {
    // NOT INCLUDED: GROUP_COORDINATOR, GROUPADMIN, GROUPMANAGER, GROUP, USER, LOCMGR
    return role === UserRoles.ADMIN;
  }

  canEditThresholdProperties(role: UserRoles) {
    // NOT INCLUDED: GROUPMANAGER, GROUP, USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUPADMIN ||
      role === UserRoles.GROUP_COORDINATOR
    );
  }
}
